// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1ORBg","tab":"Tabs_tab__3wYOO","tabActive":"Tabs_tabActive__2h-L2"};